import React, {Component} from 'react';
import { Link } from 'react-router-dom';
class Blog extends Component {
    render() {
	    return (
		<div className="blog-page">
			<div className="breadcrumbs overlay"  style={{backgroundImage: 'url("../img/bread-bg.jpeg")' ,backgroundSize: "cover" , backgroundPosition: "center" , position: "relative" , padding: "150px 0px 75px"}}>
				<div className="container">
					<div className="bread-inner" >
						<div className="row">
							<div className="col-12">
								<h2>Our Blog</h2>
								<ul className="bread-list">
									<li><a href="index.html">Home</a></li>
									<li><i className="icofont-simple-right"></i></li>
									<li className="active">Blog</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
           
			<section className="blog section" id="blog">
					<div className="container">
						<div className="row">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Helping Companies in  Their Green Transition</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog2.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Our Mission 2040: Zero  Emissions</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog3.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Key Logistics Trends in Life  Sciences 2021</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
		</div>
		);
    }
}
export default Blog;